import * as React from 'react'
import classNames from 'classnames'
import { Parallax } from 'react-parallax'

import type { Image } from 'types'
import { parseImageSrc } from 'ui-component-library/utils/helpers'
import MainInfo from './MainInfo'
import PromoCard from './PromoCard'
import style from './style.scss'

type Card = {
  bodyText: string
  headlineText: string
  image: Image
}

type Props = {
  className?: string
  cards: Card[]
  image: Image
  mainInfo: {
    bodyText: string
    headlineText: string
  }
  imageDarken: boolean
}

function FullWidthPromoWithCards(props: Props) {
  const { className, mainInfo, image, imageDarken, cards } = props
  const { src: imageSrc } = image
  const { srcSet: bgImageSrcSet, src: bgImage } = parseImageSrc(imageSrc)

  return (
    <div className={classNames(style.wrapper, className)}>
      <Parallax bgImage={bgImage} bgImageSrcSet={bgImageSrcSet} strength={75}>
        <div
          className={classNames(style.innerContent, {
            [style.darken]: imageDarken,
          })}
        >
          <MainInfo className={style.mainInfo} {...mainInfo} />
          <div className={classNames(style.cardsContainer)}>
            {cards.map((item, index) => (
              <PromoCard
                key={index}
                bodyText={item.bodyText}
                headlineText={item.headlineText}
                image={item.image}
              />
            ))}
          </div>
        </div>
      </Parallax>
    </div>
  )
}

export default FullWidthPromoWithCards
